export default __webpack_public_path__ + "static/media/smartmockups_jzwdpybx.85beaa32.png";